import { CatalystColors } from "@certa/catalyst/constants/styles";
import { css } from "emotion";

export const hiddenCountPillStyles = css({
  borderRadius: "var(--small-border-radius)",
  color: "var(--colors-neutral-700)",
  cursor: "pointer",
  backgroundColor: "var(--colors-neutral-300)"
});

export const hierarchyItemStyles = (isMobileResolution: boolean) =>
  css({
    maxWidth: "max-content",
    overflow: "hidden",
    whiteSpace: "nowrap",
    flexBasis: "0%",
    textOverflow: "ellipsis",
    flexGrow: 1
  });

export const separatorStyles = css({
  maxWidth: "min-content"
});

export const messageStyles = css({
  padding: "2px 0",
  lineClamp: 3,
  overflowWrap: "anywhere",
  color: CatalystColors.NEUTRAL_700
});

export const hierarchyFlexItemStyles = css({
  flexBasis: "0%",
  maxWidth: "max-content",
  overflow: "hidden",
  flexGrow: 1
});
